import React, { useEffect } from 'react';
import SnackbarUtils from 'utils/SnackbarUtils';
import { ModalManager } from '../ModalManager';
import { TooltipManager } from '../TooltipManager';
import { useSnackbar } from 'notistack';
import styles from './Layout.scss';
import Navbar from 'components/Navbar/Navbar';
import LeftSidebar from '../../components/LeftSidebar/LeftSidebar';
import FloatingHelpButton from 'components/FloatingHelpButton';

const rootClassName = styles.rootClassName;

const Layout = (props) => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    SnackbarUtils.setSnackBar(enqueueSnackbar, closeSnackbar);
  }, [enqueueSnackbar, closeSnackbar]);

  return (
    <>
      <LeftSidebar />
      <Navbar />
      <div className={`${rootClassName}-layout-container`}>{props.children}</div>
      <FloatingHelpButton />
      <ModalManager />
      <TooltipManager />
    </>
  );
};

export default Layout;